import {addPutMethodToForm, post} from '../utils'
import {makeFormData, root} from './utils'

export default host => ({ id, translations, clientCategories, review, order }) =>
  post(`${host}${root}/${id}`, addPutMethodToForm(makeFormData(translations, clientCategories, review, order)))
    .then(response => response.json())
